

module.exports = __webpack_require__.stylable.create(
    "o3",
    {"classes":{"root":"s313","anchor":"s132","isActive":"s149"},"vars":{"nav-link-colour":"--o4-nav-link-colour","base-font-family":"--o4-base-font-family","base-font-size":"--o4-base-font-size","spacing-unit-x2":"--o4-spacing-unit-x2"},"stVars":{},"keyframes":{}},
    "",
    3,
    7,
    null
);
